import React, {useCallback, useContext, useEffect, useState} from 'react';
import {Button, SegmentedGroup, Segmented, setOptions, toast} from "@mobiscroll/react";
import '@mobiscroll/react/dist/css/mobiscroll.min.css';
import '../styles/dashboardWorkspaceImage.css';
import Empty from "../utils/Empty";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCloudArrowDown, faCopy, faFileImage, faQrcode, faXmark} from "@fortawesome/pro-duotone-svg-icons";
import Print from "../utils/Print";
import QR from "../utils/QR";
import {NetworkContext} from "../utils/NetworkContext";

setOptions({
    theme: 'ios',
    themeVariant: 'light',
});

function DashboardWorkspaceImage({locale, workspaceItem, setLoading, teamtalk, navigation, width, ButtonBack, setToast, setWorkspaceItem}) {
    const {wsCall, wsResponse, setWsResponse} = useContext(NetworkContext);
    const [menu, setMenu] = useState('original');
    const [image, setImage] = useState("data:" + workspaceItem.data.mime + ";base64," + workspaceItem.file);
    const [update, setUpdate] = useState(workspaceItem.update ? ("data:" + workspaceItem.data.update.mime + ";base64," + workspaceItem.data.update.file) : null);
    const [iconHover, setIconHover] = useState(null);
    const [qr, setQr] = useState(null);
    const [dialog, setDialog] = useState({});

    const ImageClose = useCallback(() => {
        ButtonBack();
    }, [ButtonBack]);

    const ImageCopy = async () => {
        try {
            const response = await fetch(image);
            const blob = await response.blob();

            await navigator.clipboard.write([
                new ClipboardItem({ [blob.type]: blob })
            ]);

            toast({message: locale.dashboardWorkspaceImage.e, color: 'info', display: 'bottom', duration: 1000});
        } catch (error) {
            console.error('Failed to copy to clipboard:', error);
            toast({message: locale.dashboardWorkspaceImage.f, color: 'danger', display: 'bottom', duration: 3000});
        }
    }

    const ImageShare = () => {
        if (workspaceItem.data.shared) {
            const url = "https://ai.cubicstone.com/?a=" + workspaceItem.data.shared;

            setQr({
                url: url,
                title: null
            })
            setDialog({view: 'utilsQr'});
        } else {

            const message = {
                type: 'wss',
                path: 'shortener-app',
                action: 'put',
                data: {
                    path: 'app',
                    type: 'qr',
                    app: workspaceItem.id,
                    teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id} : null
                }
            };
            wsCall(message);
        }
    }

    const ImageDownload = () => {
        setToast({message: locale.dashboardWorkspaceImage.h, color: 'info', display: 'bottom'});

        const message = {
            type: 'wss',
            path: 'workspace-file',
            action: 'get',
            data: {
                id: workspaceItem.id,
                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id} : null
            }
        };
        wsCall(message);
    }

    const ButtonUpdate = data => {
        setLoading(true);

        const message = {
            type: 'wss',
            path: 'workspace-item',
            action: 'update',
            data: {
                id: workspaceItem.id,
                teamtalk:  (!Empty(teamtalk) && teamtalk.id) ? {id: teamtalk.id, users: teamtalk.users} : null,
                tab: (!Empty(teamtalk) && teamtalk.id) ? null : navigation.tab
            }
        };
        if (data === 'accept') {
            message.data.accept = true;
        }
        if (data === 'reject') {
            message.data.reject = true;
        }
        wsCall(message);
    }

    const SegmentedUpdate = data => {
        setMenu(data.target.value);
    }

    const PutShortenerApp = useCallback(data => {
        if (data.shared) {
            const item = workspaceItem;
            item.data.shared = data.shared;
            setWorkspaceItem(item);
        }
        if (data.qr) {
            setQr(data.qr);
            setDialog({view: 'utilsQr'});
        }
    }, [workspaceItem]);

    useEffect(() => {
        if (wsResponse && !Empty(wsResponse) && wsResponse.action === 'put' && wsResponse.path === 'shortener-app') {
            PutShortenerApp(wsResponse.data);
            setWsResponse({});
        }
    }, [wsResponse, PutShortenerApp, setWsResponse]);

    return (
        <div className="cs-dashboard-workspace-image-fullscreen">
            <div className="mbsc-row cs-dashboard-workspace-image-header" >
                <div className="mbsc-col cs-dashboard-workspace-image-col-start" >
                    {((width > 576 && !workspaceItem.public) || workspaceItem.public) &&
                        <Button color="secondary" variant="flat"  className="mbsc-bold cs-dashboard-workspace-image-color" >
                            <FontAwesomeIcon className="cs-dashboard-workspace-image-icon" icon={faFileImage} />
                            {((width > 992 && !workspaceItem.public) || (width > 576 && workspaceItem.public)) &&
                                <div className="cs-dashboard-workspace-image-menu-text">
                                    {workspaceItem.name}
                                </div>
                            }
                            {width < 992 && !workspaceItem.public &&
                                <>&nbsp;</>
                            }
                        </Button>
                    }
                </div>
                <div className="mbsc-col-auto" >
                    <div className="mbsc-row cs-dashboard-workspace-image-col-end">
                        <Button onMouseEnter={() => setIconHover('share')} onMouseLeave={() => setIconHover(null)} color="primary" variant="flat" className="mbsc-bold cs-dashboard-workspace-image-color" onClick={() => ImageShare()} >
                            {width > 576 && workspaceItem.public && <>&nbsp;</>}<FontAwesomeIcon className="cs-dashboard-workspace-image-icon" icon={faQrcode} beatFade={iconHover === 'share'} />{width > 576 && !workspaceItem.public && <div className="cs-dashboard-workspace-image-menu-text">{locale.dashboardWorkspaceImage.j}</div>}
                        </Button>
                        {!workspaceItem.public &&
                            <>
                                <Button onMouseEnter={() => setIconHover('download')} onMouseLeave={() => setIconHover(null)} color="primary" variant="flat" className="mbsc-bold cs-dashboard-workspace-image-color" onClick={() => ImageDownload()} >
                                    <FontAwesomeIcon className="cs-dashboard-workspace-image-icon" icon={faCloudArrowDown} fade={iconHover === 'download'} />{width > 768 && <div className="cs-dashboard-workspace-image-menu-text">{locale.dashboardWorkspaceImage.i}</div>}
                                </Button>
                                <Button onMouseEnter={() => setIconHover('copy')} onMouseLeave={() => setIconHover(null)} color="primary" variant="flat" className="mbsc-bold cs-dashboard-workspace-image-color" onClick={() => ImageCopy()} >
                                    <FontAwesomeIcon className="cs-dashboard-workspace-image-icon" icon={faCopy} fade={iconHover === 'copy'} />{width > 768 && <div className="cs-dashboard-workspace-image-menu-text">{locale.dashboardWorkspaceImage.g}</div>}
                                </Button>
                                <Print
                                    width={width}
                                    locale={locale}
                                    name={workspaceItem.name}
                                    htmlContent={`<img src="${image}" alt="${workspaceItem.name}" style="width:100%;max-width:700px;" />`}
                                    GetContent={null}
                                />
                                <Button onMouseEnter={() => setIconHover('close')} onMouseLeave={() => setIconHover(null)} color="primary" variant="flat" className="mbsc-bold cs-dashboard-workspace-image-color" onClick={() => ImageClose()} >
                                    <FontAwesomeIcon className="cs-dashboard-workspace-image-icon" icon={faXmark} fade={iconHover === 'close'} />
                                </Button>
                            </>
                        }

                    </div>
                </div>
            </div>
            {!workspaceItem.public && workspaceItem.update &&
                <div className="mbsc-row cs-dashboard-workspace-image-header-secondary" >
                    <div className="mbsc-col" />
                    <div className="mbsc-col-auto" >
                        <div className="mbsc-row cs-dashboard-workspace-image-col-end">
                            <Button color="primary" variant="flat" className="mbsc-bold mbsc-txt-muted cs-dashboard-workspace-image-color" onClick={() => ButtonUpdate('accept')} >
                                {locale.dashboardWorkspaceImage.c}
                            </Button>
                            <Button color="primary" variant="flat" className="mbsc-bold mbsc-txt-muted cs-dashboard-workspace-image-color" onClick={() => ButtonUpdate('reject')} >
                                {locale.dashboardWorkspaceImage.d}
                            </Button>
                        </div>
                    </div>
                </div>
            }
            {!workspaceItem.public && workspaceItem.update &&
                <div className="mbsc-row mbsc-justify-content-center cs-dashboard-workspace-image-section-update">
                    <div className="mbsc-col-12 mbsc-col-sm-12 mbsc-col-md-10 mbsc-col-lg-8 mbsc-col-xl-6">
                        <SegmentedGroup className="cs-dashboard-workspace-image-update" name="update" color="primary" value={menu} onChange={SegmentedUpdate}>
                            <Segmented value="original" >
                                {locale.dashboardWorkspaceImage.a}
                            </Segmented>
                            <Segmented value="update" >
                                {locale.dashboardWorkspaceImage.b}
                            </Segmented>
                        </SegmentedGroup>
                    </div>
                </div>
            }
            {(workspaceItem.public || !workspaceItem.update || (workspaceItem.update && menu === 'original')) &&
                <div className="mbsc-row cs-dashboard-workspace-image-section">
                    <div className="mbsc-col cs-dashboard-workspace-image-editor">
                        <div style={{backgroundImage: `url(${image})`}} className="cs-dashboard-workspace-image-canvas"  />
                    </div>
                </div>
            }
            {!workspaceItem.public && workspaceItem.update && menu === 'update' &&
                <div className="mbsc-row cs-dashboard-workspace-image-section">
                    <div className="mbsc-col cs-dashboard-workspace-image-editor">
                        <div style={{backgroundImage: `url(${update})`}} className="cs-dashboard-workspace-image-canvas"  />
                    </div>
                </div>
            }
            {dialog.view === 'utilsQr' && !Empty(qr) &&
                <QR
                    setQr={setQr}
                    dialog={dialog}
                    setDialog={setDialog}
                    qr={qr}
                    width={width}
                    locale={!Empty(locale) ? locale : {}}
                />
            }
        </div>
    );
}

export default DashboardWorkspaceImage;
